import React from "react";
import DOMPurify from "dompurify";

import styles from "./TemplatePreview.module.css";

const removeImages = (html) =>
  typeof html === "string" ? html.replace(/<img\b[^>]*>/gi, "") : html;

export const TemplatePreview = ({ html, stripImages = false }) => {
  if (!html) return null;

  const source = stripImages ? removeImages(html) : html;
  const sanitized = DOMPurify.sanitize(source, {
    ADD_DATA_URI_TAGS: ["img"],
  });

  return (
    <div
      className={`ql-editor ${styles.preview}`}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
};
